module.exports = __webpack_public_path__ + "img/24_rain.2a9f8006.jpg";